/**
 * Affiliate payout (commission period) status metadata — ADMIN copy.
 *
 * Labels/tones intentionally match the affiliate-side map planned at
 * `src/affiliate/utils/affiliatePayoutStatusMeta.js` (eng-00099 spec). That
 * file is owned by another implementation unit and may not exist yet, so the
 * admin dashboard keeps this tiny local duplicate instead of importing it.
 *
 * `tone` maps 1:1 onto the design-system `StatusBadge` variants
 * (success | warning | danger | neutral | info).
 */

export const AFFILIATE_PAYOUT_STATUSES = [
  "estimated",
  "pending_setup",
  "on_hold",
  "pending_approval",
  "queued_for_payout",
  "completed",
  "failed",
  "rejected",
  "reversed",
];

export const AFFILIATE_PAYOUT_STATUS_META = {
  estimated: { label: "Estimated", tone: "neutral" },
  pending_setup: { label: "Pending setup", tone: "warning" },
  on_hold: { label: "On hold (14 days)", tone: "info" },
  pending_approval: { label: "Pending approval", tone: "warning" },
  queued_for_payout: { label: "Processing payout", tone: "info" },
  completed: { label: "Paid", tone: "success" },
  failed: { label: "Failed", tone: "danger" },
  rejected: { label: "Rejected", tone: "danger" },
  reversed: { label: "Reversed", tone: "neutral" },
};

export const getAffiliatePayoutStatusMeta = (status) =>
  AFFILIATE_PAYOUT_STATUS_META[status] || { label: status || "Unknown", tone: "neutral" };
